import createSubflowsFromDefns from './_createSubflowsFromDefns';
import flowBegining from './_flowBegining';
import wireLOBSection from './_wireLOBSection';

export default ['AvailabilityService', 'qnb.LoadSaveService', '$q', 'TranslateService', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.ActionMessageUtil', 'EventHub', function (AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub) {

    function branchOnProductCode(paFlows, hoFlows, cpFlows, bopFlows, flowPropertyKey) {
        // wcFlows,
        var paTransition = paFlows[flowPropertyKey] ? paFlows[flowPropertyKey].entry : null;
        var hoTransition = hoFlows[flowPropertyKey] ? hoFlows[flowPropertyKey].entry : null;
        var cpTransition = cpFlows && cpFlows[flowPropertyKey] ? cpFlows[flowPropertyKey].entry : null;
        var bopTransition = bopFlows && bopFlows[flowPropertyKey] ? bopFlows[flowPropertyKey].entry : null;
        var wcTransition = wcFlows && wcFlows[flowPropertyKey] ? wcFlows[flowPropertyKey].entry : null;

        return function (_ref) {
            var submission = _ref.value;

            if (submission.baseData.productCode === 'PersonalAuto') {
                return paTransition;
            }
            if (submission.baseData.productCode === 'Homeowners' || submission.baseData.productCode === 'HOPHomeowners') {
                return hoTransition;
            }
            if (submission.baseData.productCode === 'CommercialProperty') {
                return cpTransition;
            }
            if (submission.baseData.productCode === 'BusinessOwners') {
                return bopTransition;
            }
            if (submission.baseData.productCode === 'WorkersComp') {
                console.log('integration.quoteandbind.config.CompositeFlowConfig');
                return wcTransition;
            }
            throw new Error('Invalid Product code specified.');
        };
    }

    return function (step, junction, flow) {

        var subFlows = createSubflowsFromDefns(flow, AvailabilityService, LoadSaveService, $q, TranslateService, ViewModelService, ViewModelCtx, ActionMessageUtil, EventHub);
        // create complete flow by wiring up sub flows
        flowBegining(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
        wireLOBSection(subFlows, branchOnProductCode, TranslateService)(step, junction, flow);
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/config/CompositeFlowConfig.js
// module id = 2223
// module chunks = 0